import React from "react";
import styled from "styled-components/macro";
import { useSelector, useDispatch } from "react-redux";

import { SET_ACTIVE_VIEW_INDEX } from "../../store/actions/viewActions";
import { SET_SIDE_MENU_OPEN } from "../../store/actions/menuActions";
import { CLEAR_PREVIEW_ITEM } from "../../store/actions/configurationActions";
import { getActiveViewIndex, getMaxViewIndex } from "../../store/sagas/selectors";
import Constants from "../../constants";

import { useBreakpoint } from "../../utilities/media-js-breakpoints";

const Catcher = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
`;

const EventCatcher = ({ onBackdropClick }: { onBackdropClick: () => {} }) => {
    const dispatch = useDispatch();
    const maxIndex = useSelector(getMaxViewIndex);
    const activeIndex = useSelector(getActiveViewIndex);

    const breakpoints = useBreakpoint();

    let SwipeStart: number = 0;
    let TouchMovePosition: number = 0;
    const MinSwipeDistance: number = 45;

    const TouchStart = (touchStartEvent: any) => {
        TouchMovePosition = touchStartEvent.targetTouches[0].clientX;
        onSwipeStart(touchStartEvent.targetTouches[0].clientX);
    };

    const TouchMove = (touchMoveEvent: any) => {
        TouchMovePosition = touchMoveEvent.targetTouches[0].clientX;
    };

    const TouchEnd = () => {
        onSwipeEnd(TouchMovePosition);
    };

    const MouseDown = (mouseDownEvent: any) => {
        mouseDownEvent.preventDefault();
        onSwipeStart(mouseDownEvent.clientX);
    };

    const MouseUp = (mouseDownEvent: any) => {
        mouseDownEvent.preventDefault();
        onSwipeEnd(mouseDownEvent.clientX);
    };

    const onSwipeStart = (clientX: any) => {
        SwipeStart = clientX;
    };

    const onSwipeEnd = (clientX: any) => {
        const SwipeDistance = SwipeStart - clientX;
        const SwipeDirection = SwipeDistance < 0 ? -1 : 1;

        if (Math.abs(SwipeDistance) > MinSwipeDistance) {
            if (activeIndex === 0 && SwipeDirection === -1) {
                dispatch({ type: SET_ACTIVE_VIEW_INDEX, activeViewIndex: maxIndex });
                return;
            }

            if (activeIndex === maxIndex && SwipeDirection === 1) {
                dispatch({ type: SET_ACTIVE_VIEW_INDEX, activeViewIndex: 0 });
                return;
            }

            if (activeIndex !== null) {
                dispatch({ type: SET_ACTIVE_VIEW_INDEX, activeViewIndex: activeIndex + SwipeDirection });
            }
        }
    };

    const handleBackdropClick = () => {
        // Close the menu when not clicking on anything important.
        dispatch({ type: SET_SIDE_MENU_OPEN, sideMenuOpen: false });
        dispatch({ type: CLEAR_PREVIEW_ITEM });
        onBackdropClick();
    };

    let height;
    if (breakpoints.landscape) {
        height = `${Constants.desktopImageHeightPercent}%`;
    } else {
        height = `${Constants.mobileImageHeightVw}vw`;
    }

    return (
        <Catcher
            style={{ height }}
            onTouchStart={touchStartEvent => TouchStart(touchStartEvent)}
            onTouchEnd={touchEndEvent => TouchEnd()}
            onTouchMove={touchMoveEvent => TouchMove(touchMoveEvent)}
            onMouseDown={mouseDownEvent => MouseDown(mouseDownEvent)}
            onMouseUp={mouseUpEvent => MouseUp(mouseUpEvent)}
            onClick={handleBackdropClick}
        />
    );
};

export default EventCatcher;
